module.exports = __webpack_public_path__ + "static/media/update_notification_configuration_template.6382183f.xlsx";